// role DPM
export const ROLE_DPM = ['dokter_praktek'];
export const ROLE_DPM_OPERATOR = ['dokter_praktek', 'operator'];

// role klinik
export const ROLE_DOKTER = ['dokter_klinik'];
export const ROLE_PIC = ['pic_pusat', 'pic_cabang'];
export const ROLE_MANAGEMENT = ['owner_klinik', 'manajemen'];
export const ROLE_REKAM_MEDIS = ['pic_cabang', 'dokter_klinik'];
export const ROLE_FARMASI = ['pic_pusat', 'pic_cabang', 'apoteker'];
export const ROLE_FRONTDESK = ['pic_cabang', 'frontdesk', 'kasir', 'apoteker'];
export const ROLE_FRONT_NON_APOTEKER = ['pic_pusat', 'pic_cabang', 'frontdesk', 'kasir'];
export const ROLE_ALL_MANAGEMENT = ['owner_klinik', 'pic_pusat', 'pic_cabang', 'manajemen'];
export const ROLE_RIWAYAT_REKAM_MEDIS = ['pic_cabang', 'dokter_klinik', 'perawat', 'apoteker'];
export const ROLE_FRONT_MANAGEMENT = ['pic_pusat', 'pic_cabang', 'apoteker', 'frontdesk', 'kasir'];
export const ROLE_NON_MANAGEMENT = ['pic_pusat', 'pic_cabang', 'dokter_klinik', 'perawat', 'apoteker', 'frontdesk', 'kasir'];
export const ROLE_KLINIK = ['owner_klinik', 'manajemen', 'pic_cabang', 'pic_pusat', 'dokter_klinik', 'perawat', 'frontdesk', 'kasir', 'apoteker'];
export const ROLE_ALL = [...ROLE_KLINIK, ...ROLE_DPM_OPERATOR];
export const ROLE_MANAGEMENT_DOKTER = [...ROLE_ALL_MANAGEMENT, ...ROLE_DOKTER];
export const ROLE_FRONT_DOKTER = [...ROLE_FRONT_MANAGEMENT, ...ROLE_DOKTER];

// sidebar menu
export const MENUS = [
  {
    title: 'Dashboard',
    href: '/',
    type: ROLE_ALL,
    icon: {
      element: 'sidebar-image',
      attributes: {
        svg: 'dashboard'
      }
    },
  },

  // ================= MENU DPM ================== //
  {
    title: 'Registrasi Antrean',
    href: '/rawat-jalan/registrasi',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-alt'
      }
    },
  },
  {
    title: 'Antrean',
    href: '/rawat-jalan/antrean',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'clone'
      }
    },
  },
  {
    title: 'Daftar Pasien',
    href: '/pasien',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'user'
      }
    },
  },
  {
    title: 'Rekam Medis',
    href: '/rekam-medis',
    type: ROLE_DPM,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-medical'
      }
    },
  },
  {
    title: 'Manajemen Pengguna',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'th-large'
      }
    },
    child: [
      {
        title: 'Manajemen Asisten Dokter',
        href: '/asisten-dokter',
        type: ROLE_DPM,
      },
      {
        title: 'Manajemen Tarif',
        href: '/tarif',
        type: ROLE_DPM_OPERATOR,
      }
    ]
  },
  {
    title: 'Pembayaran',
    href: '/pembayaran',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'archive'
      }
    },
  },
  {
    title: 'Subskripsi',
    href: '/subskripsi',
    type: ROLE_DPM,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'money-bill'
      }
    },
  },
  {
    title: 'Account Setting',
    type: ROLE_DPM,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'cog'
      }
    },
    child: [
      {
        title: 'Profil Dokter',
        href: '/profile',
        type: ROLE_DPM_OPERATOR,
      }
    ]
  },
  {
    title: 'Add Ons',
    type: ROLE_DPM_OPERATOR,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'puzzle-piece'
      }
    },
    child: [
      {
        title: 'Patient Engagement',
        href: '/patient-engagement',
        type: ROLE_DPM_OPERATOR,
      }
    ]
  },

  // ================= MENU KLINIK ================== //
  // Setting Management
  {
    title: 'Setting Manajemen',
    type: ROLE_ALL_MANAGEMENT,
    icon: {
      element: 'sidebar-image',
      attributes: {
        svg: 'setting-manajemen'
      }
    },
    child: [
      {
        title: 'Tambah Klinik & PIC',
        href: '/klinik',
        type: ROLE_MANAGEMENT,
        icon: {
          element: 'sidebar-image',
          attributes: {
            svg: 'klinik-pic'
          }
        },
      },
      {
        title: 'Tambah Dokter & Staff',
        href: '/dokter',
        type: ROLE_PIC,
        icon: {
          element: 'sidebar-image',
          attributes: {
            svg: 'dokter-staff'
          }
        },
      },
      {
        title: 'Tambah Manajemen',
        href: '/manajemen',
        type: ROLE_MANAGEMENT,
        icon: {
          element: 'sidebar-image',
          attributes: {
            svg: 'manajemen'
          }
        }
      },
      {
        title: 'Role Manajemen',
        href: '/role-manajemen',
        type: ROLE_MANAGEMENT_DOKTER,
        icon: {
          element: 'sidebar-image',
          attributes: {
            svg: 'role'
          }
        },
      },

      {
        title: 'Manajemen Poliklinik',
        href: '/poliklinik',
        type: ROLE_PIC,
        icon: {
          element: 'sidebar-image',
          attributes: {
            svg: 'klinik'
          }
        },
      }
    ]
  },
  // Management Tarif
  {
    title: 'Manajemen Tarif',
    href: '/manajemen-tarif',
    type: ROLE_NON_MANAGEMENT,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'money-bill'
      }
    },
  },
  // Management Obat
  {
    title: 'Manajemen Obat & BHP',
    href: '/klinik/obat',
    type: ROLE_NON_MANAGEMENT,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-medical'
      }
    },
  },
  // Stok
  {
    title: 'Manajemen Stok',
    type: ROLE_FARMASI,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-medical'
      }
    },
    child: [
      {
        title: 'Data Stok',
        href: '/klinik/stok/obat',
        type: ROLE_FARMASI,
      },
      {
        title: 'Laporan Stok',
        href: '/klinik/stok/report',
        type: ROLE_FARMASI,
      }
    ]
  },
  // Daftar Pasien
  {
    title: 'Daftar Pasien',
    href: '/pasien-klinik',
    type: ROLE_FRONTDESK,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'user'
      }
    },
  },
  // Registrasi Antrean
  {
    title: 'Registrasi Antrean',
    type: ROLE_FRONT_NON_APOTEKER,
    href: '/antrean-klinik/bridge',
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-alt'
      }
    },
  },
  // List Antrean
  {
    title: 'Antrean',
    type: ROLE_NON_MANAGEMENT,
    href: '/antrean-klinik',
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'clone'
      }
    },
  },
  // Rekam Medis
  {
    title: 'Rekam Medis',
    href: '/klinik/rekam-medis',
    type: ROLE_REKAM_MEDIS,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'file-medical'
      }
    },
  },
  //Farmasi
  {
    title: 'Farmasi',
    href: '/klinik/farmasi',
    type: ROLE_FARMASI,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'stethoscope'
      }
    },
  },
  // Pembayaran
  {
    title: 'Pembayaran',
    href: '/klinik/pembayaran',
    type: ROLE_FRONT_NON_APOTEKER,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'money-bill'
      }
    },
  },
  // Subskripsi
  {
    title: 'Subskripsi',
    href: '/klinik/subskripsi',
    type: ROLE_PIC,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'money-bill'
      }
    },
  },
  //Penjualan
  {
    title: 'Penjualan',
    href: '/klinik/penjualan',
    type: ROLE_FRONT_MANAGEMENT,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'briefcase'
      }
    },
  },
  //KYC
  {
    title: 'Know Your Customers (KYC)',
    href: '/klinik/kyc',
    type: ROLE_NON_MANAGEMENT,
    is_satusehat: true,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'users'
      }
    },
  },
  // Komisi
  {
    title: 'Komisi',
    type: ROLE_PIC,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'money-bill'
      }
    },
    child: [
      {
        title: 'Manajemen Komisi',
        href: '/klinik/komisi',
        type: ROLE_PIC,
      },
      {
        title: 'Laporan Komisi',
        href: '/klinik/komisi/report',
        type: ROLE_PIC,
      }
    ]
  },
  //Account Setting
  {
    title: 'Pengaturan Akun',
    type: ROLE_KLINIK,
    icon: {
      element: 'font-awesome-icon',
      attributes: {
        icon: 'cog'
      }
    },
    child: [
      {
        title: 'Profil Faskes',
        type: ROLE_PIC,
        href: '/account-setting/faskes-profile',
        icon: {
          element: 'font-awesome-icon',
          attributes: {
            icon: 'hospital'
          }
        },
      },
      {
        title: 'Profil',
        type: ROLE_KLINIK,
        href: '/account-setting/klinik',
        is_profile_user: true,
        icon: {
          element: 'font-awesome-icon',
          attributes: {
            icon: 'address-book'
          }
        },
      },
      {
        title: 'Pengaturan Faskes',
        type: ROLE_PIC,
        href: '/account-setting/faskes-setting',
        icon: {
          element: 'font-awesome-icon',
          attributes: {
            icon: 'user-cog'
          }
        },
      },
    ]
  },
];

export const MENU_SETTING = {
  title: 'Settings',
  type: ROLE_KLINIK,
  icon: {
    element: 'sidebar-image',
    attributes: {
      svg: 'setting'
    }
  },
  child: [
    {
      title: 'Ubah Klinik',
      href: '/change-klinik',
      type: ROLE_KLINIK,
      icon: {
        element: 'sidebar-image',
        attributes: {
          svg: 'ubah-klinik'
        }
      },
    },
  ]
}